import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { FloatingAlertList, FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { useEffect, useRef, useState } from 'react';
import { AdminModalTypes } from '../../../constants/adminModalTypes';
import { useIsAdmin } from '../../../hooks/useIsAdmin';
import { isUpgradePoint } from '../../../utils/ums';
import { getTrackingProperties, track } from '../../../utils/usageTracker';
import { AdminModal } from '../../AdminModal/AdminModal';
import { ErrorBoundary, ErrorBoundaryNames } from '../../ErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RequestProductButtonBase = ({
  apiName,
  children,
  location,
  trackingData,
  upgradeConfig,
  uiButtonProps,
  'data-test-id': dataTestId,
  'data-selenium-id': dataSeleniumId,
  onClick
}) => {
  const [adminModalOpen, setAdminModalOpen] = useState(false);
  const alertStore = useRef(FloatingAlertStore.newFloatingAlertStore());
  const isAdmin = useIsAdmin('BILLING');

  // wait for the admin check to complete before showing the button
  const buttonReady = isAdmin !== null;
  const trackingProperties = getTrackingProperties({
    apiName,
    trackingData,
    upgradeConfig
  });
  useEffect(() => {
    track('requestProductButton', Object.assign({
      action: 'viewed'
    }, trackingProperties));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleButtonClick = () => {
    onClick === null || onClick === void 0 || onClick('REQUEST_ACCESS');
    setAdminModalOpen(true);
    track('requestProductButton', Object.assign({
      action: 'clicked'
    }, trackingProperties));
    if (isUpgradePoint(location)) {
      track('interaction', Object.assign({
        action: 'clicked upgrade point'
      }, trackingProperties));
    }
  };
  if (!buttonReady) {
    return /*#__PURE__*/_jsx(LoadingButton, Object.assign({}, uiButtonProps, {
      loading: true,
      children: children !== null && children !== void 0 ? children : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.buttons.requestAccess"
      })
    }));
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FloatingAlertList, {
      alertStore: alertStore.current
    }), adminModalOpen && /*#__PURE__*/_jsx(AdminModal, {
      alertStore: alertStore.current,
      apiName: apiName,
      modalType: AdminModalTypes.REQUEST_SKU,
      trackingData: trackingData,
      upgradeConfig: upgradeConfig,
      onClose: () => setAdminModalOpen(false)
    }), /*#__PURE__*/_jsx(Button, Object.assign({}, uiButtonProps, {
      "data-test-id": dataTestId !== null && dataTestId !== void 0 ? dataTestId : 'request-product-button',
      "data-selenium-id": dataSeleniumId,
      disabled: (uiButtonProps === null || uiButtonProps === void 0 ? void 0 : uiButtonProps.disabled) || !buttonReady,
      truncate: true,
      truncateStringProps: {
        justifyContent: 'center'
      },
      onClick: handleButtonClick,
      children: children !== null && children !== void 0 ? children : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.buttons.requestAccess"
      })
    }))]
  });
};
export const RequestProductButton = props => /*#__PURE__*/_jsx(ErrorBoundary, {
  boundaryName: ErrorBoundaryNames.REQUEST_ACCESS_BUTTON,
  children: /*#__PURE__*/_jsx(RequestProductButtonBase, Object.assign({}, props))
});